import { render } from "./Meal.vue?vue&type=template&id=9c272068&scoped=true"
import script from "./Meal.vue?vue&type=script&lang=js"
export * from "./Meal.vue?vue&type=script&lang=js"

import "./Meal.vue?vue&type=style&index=0&id=9c272068&scoped=true&lang=css"

import exportComponent from "/Users/don/phpStorm/qr-menu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c272068"]])

export default __exports__